export const EXTRA_ACTIVITY_DELETE_ACTION_LABEL = 'Delete extra activity';

const getExtraActivity = (record) => record?.activity ?? record ?? {};

export const getDeleteExtraActivityPayload = (record) => {
	const extraActivity = getExtraActivity(record);

	return {
		initialData: {
			workAssignmentKey: {
				id: extraActivity.id,
				version: extraActivity.version,
			},
		},
	};
};

export const canDeleteExtraActivity = (record) => {
	const extraActivity = getExtraActivity(record);

	return Boolean(
		extraActivity.id && extraActivity.version !== undefined && extraActivity.version !== null
	);
};

export const getExtraActivityActions = (record, onDeleteExtraActivity) => {
	if (!canDeleteExtraActivity(record)) return [];

	return [
		{
			id: 'delete-extra-activity',
			label: EXTRA_ACTIVITY_DELETE_ACTION_LABEL,
			action: () => onDeleteExtraActivity(record),
		},
	];
};
